export class UpdateCloudResourceConfigurationRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cdcBackup",
            "baseName": "cdcBackup",
            "type": "UpdateCloudResourceConfigurationRequestCdcBackup",
            "format": ""
        },
        {
            "name": "inventoryBackup",
            "baseName": "inventoryBackup",
            "type": "UpdateCloudResourceConfigurationRequestInventoryBackup",
            "format": ""
        },
        {
            "name": "setDynamoDbPartitions",
            "baseName": "setDynamoDbPartitions",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setDynamoDbBinDurationMinutes",
            "baseName": "setDynamoDbBinDurationMinutes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setDynamoDbPartitionItems",
            "baseName": "setDynamoDbPartitionItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setStorageLayerBackupProcessorsPerPartition",
            "baseName": "setStorageLayerBackupProcessorsPerPartition",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setStorageLayerBackupMaxNodes",
            "baseName": "setStorageLayerBackupMaxNodes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setStorageLayerPartitionSchemeOverride",
            "baseName": "setStorageLayerPartitionSchemeOverride",
            "type": "string",
            "format": ""
        },
        {
            "name": "setStorageLayerMaxFullBackupInterval",
            "baseName": "setStorageLayerMaxFullBackupInterval",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setKeyspacesBinDurationMinutes",
            "baseName": "setKeyspacesBinDurationMinutes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setMongoAtlasCollectionPartitions",
            "baseName": "setMongoAtlasCollectionPartitions",
            "type": "{ [key: string]: number; }",
            "format": "int64"
        },
        {
            "name": "setMongoAtlasBinDurationMinutes",
            "baseName": "setMongoAtlasBinDurationMinutes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "setForceEc2NativeBackup",
            "baseName": "setForceEc2NativeBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "setForceGcpVmNativeBackup",
            "baseName": "setForceGcpVmNativeBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "setDbBackupMode",
            "baseName": "setDbBackupMode",
            "type": "UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum",
            "format": ""
        },
        {
            "name": "setRdsCdcDatabaseWhitelist",
            "baseName": "setRdsCdcDatabaseWhitelist",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateCloudResourceConfigurationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum;
(function (UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum) {
    UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum["None"] = "NONE";
    UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum["Cdc"] = "CDC";
    UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum["CdcReaderOnly"] = "CDC_READER_ONLY";
})(UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum || (UpdateCloudResourceConfigurationRequestSetDbBackupModeEnum = {}));
